import { useEffect, useState } from 'react'

/**
 * Breakpoint de escritorio del sidebar (Tailwind `lg`). Se centraliza aquí para
 * que el comportamiento por JS (rail colapsado, auto-contraer) y las clases
 * utilitarias nunca diverjan.
 */
export const DESKTOP_MIN_WIDTH_PX = 1024

export function isDesktopViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`).matches
}

/**
 * `true` cuando la pantalla es de escritorio (>= 1024px). El sidebar solo
 * aplica el estado colapsado allí: en móvil el cajón hamburguesa siempre se
 * abre expandido.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const query = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`)
    const onChange = (event: MediaQueryListEvent) => setIsDesktop(event.matches)
    setIsDesktop(query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  return isDesktop
}
